import React from 'react'

const FilterBtn = ({ setShowFilter }) => {
    return (
        <>
            <button
                className="btn btn-outline-primary filterBtn"
                onClick={() => {
                    setShowFilter((prev) => !prev);
                }}
            >
                <i className="i-Filter-2"></i>
            </button>
        </>
    )
}

export default FilterBtn